import { TooltipWrapper } from 'components/TooltipWrapper/TooltipWrapper';
import { Badge, IconCheck } from 'uikit';

import type React from 'react';
import { useMemo } from 'react';

import type { ITableLikeTreeFilterItem } from '../context';

import Style from './LeftFilterTitleCell.module.css';

interface ILeftFilterTitleCell {
    checkedIds: number[];
    item: ITableLikeTreeFilterItem;
    selectedId?: number;
    showCheckedMainItems?: boolean;
    checkedCountCache?: Record<string, number>;
}

export const LeftFilterTitleCell: React.FC<ILeftFilterTitleCell> = (props) => {
    const { checkedIds, item, showCheckedMainItems, checkedCountCache } = props;

    const checkedCount = useMemo(
        () => (checkedCountCache ? checkedCountCache?.[item.id] || 0 : checkedIds.length),
        [checkedCountCache, checkedIds.length, item.id],
    );

    return showCheckedMainItems && checkedCount ? (
        <div className={Style.titleCell}>
            <div>{item.title}</div>
            <TooltipWrapper message="Кол-во выбранных объектов включая подобъекты" key="revision" isInteractive={false}>
                <Badge size="s" status="normal" label={String(checkedCount)} iconLeft={IconCheck} />
            </TooltipWrapper>
        </div>
    ) : (
        <span>{item.title}</span>
    );
};

LeftFilterTitleCell.displayName = 'LeftFilterTitleCell';
